// extracted by css-extract-rspack-plugin
var _1 = "z4_iPqCAIbQzedZE";
var _2 = "VpLd0XDedRQnpyrk";
var _3 = "zg0L0RE30kufChZE";
var _4 = "Wzy4H7yUHmcdTenH";
export { _1 as "iconHolder", _2 as "pillBaseStyle", _3 as "pillSizeLarge", _4 as "pillSizeSmall" }
// extracted by css-extract-rspack-plugin
var _1 = "z4_iPqCAIbQzedZE";
var _2 = "VpLd0XDedRQnpyrk";
var _3 = "zg0L0RE30kufChZE";
var _4 = "Wzy4H7yUHmcdTenH";
export { _1 as "iconHolder", _2 as "pillBaseStyle", _3 as "pillSizeLarge", _4 as "pillSizeSmall" }
